const $ProductImageContainer = document.getElementById('Product360Container');
const $ProductImage = document.getElementById('Product360');
const $Description = document.getElementById('Description');
const $Progress = document.getElementById('Progress');
const $PDPForm = document.getElementById('PDPForm');
const $Header = document.getElementById('Header');
const $body = document.getElementsByTagName("body")[0];
const $scrollTarg = document.getElementById('Container');
var timer;
var slider = null;
var sliderInstance = null;

const year = "2026";
const month = "09";
const day = "04";
const hour = "12";
const minute = "00";

var currPage = "";
var nextPage = "";
var indexMode = "grid";

var $activeThumb = null;
var $activeProduct = null;
var scrolledPast = false;

const $index = $('#Index');
const $grid = $('#Grid');
const $table = $('#Table');

const setTimer = () => {
    var endDate = moment.tz(`${year}-${month}-${day} ${hour}:${minute}`, "America/New_York");

    $('.countdown').countdown(endDate.toDate(), function (event) {
        $(this).html(event.strftime('%d:%H:%M:%S'));
    });

    return true;
    let multipleTimers = document.querySelectorAll('.countdown');
    if (multipleTimers.length === 0) return true;
    function roundDown(floating) {
        var rounded = Math.round(floating * 100) / 100;
        return rounded;
    }
    console.log('set countdown')
    simplyCountdown(multipleTimers, { year: 2026, // required
    month: 09, // required
day: 04, // required
hours: 8, // Default is 0 [0-23] integer
    minutes: 00, // Default is 0 [0-59] integer
seconds: 00, // Default is 0 [0-59] integer
words: { //words displayed into the countdown
    days: { singular: ':', plural: ':' },
    hours: { singular: ':', plural: ':' },
    minutes: { singular: ':', plural: ':' },
    seconds: { singular: '', plural: '' }
},
plural: true, //use plurals
    inline: false, //set to true to get an inline basic countdown like : 24 days, 4 hours, 2 minutes, 5 seconds
        inlineClass: 'simply-countdown-inline', //inline css span class in case of inline = true
            // in case of inline set to false
            enableUtc: true, //Use UTC or not - default : false
                onEnd: function() { return; }, //Callback on countdown end, put your own function here
onUpdate: function(secondsLeft, totalTime) {
    // console.log(secondsLeft);
    // let countUp = totalTime - secondsLeft/totalTime;
    // let count = (secondsLeft * 100) / totalTime;
    // console.log(totalTime);
    // console.log(secondsLeft);
    $Progress.value = (100 - ((totalTime - secondsLeft) / (totalTime) * 1000) * 100).toFixed(2);
},
refresh: 1000, // default refresh every 1s
    sectionClass: 'simply-section', //section css class
        amountClass: 'simply-amount', // amount css class
            wordClass: 'simply-word', // word css class
                zeroPad: true,
                    countUp: false });
}

const winResize = () => {
    document.querySelector(':root').style.setProperty('--vh', window.innerHeight + 'px');
}

const setAnchorLinks = () => {
    const links = document.querySelectorAll(".anchor-link");

    for (const link of links) {
        link.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();
        const href = this.getAttribute("href");
        const offsetTop = document.querySelector(href).offsetTop;

        $scrollTarg.scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }
}

const setNewsletter = () => {

    const $NewsletterButton = document.getElementById('NewsletterButton');
    const $PDPNewsletterInput = document.getElementById('NewsletterInput');
    const $PDPCountdownButton = document.getElementById('PDPCountdownButton');

    if ($NewsletterButton !== null) {
        initMailchimp();

        $NewsletterButton.addEventListener('click', newsletterClick);
        $PDPCountdownButton.addEventListener('click', countdownButtonClick);

        function countdownButtonClick() {
            $body.setAttribute('data-mode', '');
        }
        function newsletterClick() {
            $body.setAttribute('data-mode', 'newsletter');
            setTimeout(function () { $PDPNewsletterInput.focus(); }, 150);
            document.addEventListener('click', documentClick);
        }
        function documentClick(e) {
            console.log(e);
            if (e.target.id !== "NewsletterButton" && e.target.id !== "NewsletterInput" && e.target.id !== "NewsletterButton") {
                $body.setAttribute('data-mode', '');
                document.removeEventListener('click', documentClick);
            }
        }
    }
}

const initMailchimp = () => {
    console.log('initmailchimp');
    document.getElementById('NewsletterForm').addEventListener('submit', function (e) {
        e.preventDefault();

        console.log('form submit');

        // Check for spam
        if (document.getElementById('js-validate-robot').value !== '') { return false }

        // Get url for mailchimp
        var url = this.action.replace('/post?', '/post-json?');

        // Add form data to object
        var data = '';
        var inputs = this.querySelectorAll('#js-form-inputs input');
        for (var i = 0; i < inputs.length; i++) {
            data += '&' + inputs[i].name + '=' + encodeURIComponent(inputs[i].value);
        }

        // Create & add post script to the DOM
        var script = document.createElement('script');
        script.src = url + data;
        document.body.appendChild(script);

        // Callback function
        var callback = 'callback';
        window[callback] = function (data) {

            // Remove post script from the DOM
            delete window[callback];
            document.body.removeChild(script);

            // Display response message
            document.getElementById('js-subscribe-response').innerHTML = data.msg.split('0 - ').join('');
            document.body.classList.add('newsletter-message');
            setTimeout(function () {
                document.getElementById('js-subscribe-response').innerHTML = '';
                document.body.classList.remove('newsletter-message');
            }, 3000);
        };
    });
}

const initLazySizes = () => {
    window.lazySizesConfig = window.lazySizesConfig || {};

    //page is optimized for fast onload event
    lazySizesConfig.loadMode = 1;
}



function setSticky() {
    const $magnet = $('.magnet');
    $(window).on('mousemove', function (e) {
        // console.log(e.clientX);
        $magnet.css('transform', `translate3d(${-e.clientX / 100}px, ${-e.clientY / 100}px, 0px)`)
    })
}

function initCarousel() {
    if ($('#Carousel').length > 0) {

        var currSlide;

        slider = new KeenSlider('#Carousel', {
            loop: true,
            duration: 0,
            defaultAnimation: {
                duration: 0
            },
            created: function (instance) {
                sliderInstance = instance;

                // Autoplay
                let timeout;
                let navigating = false;
                function clearNextTimeout() {
                  clearTimeout(timeout)
                }
                function nextTimeout() {
                  clearTimeout(timeout)
                  if (navigating) return
                  timeout = setTimeout(() => {
                    sliderInstance.next()
                  }, 4000)
                }
                nextTimeout()

                sliderInstance.on("dragStarted", clearNextTimeout)
                sliderInstance.on("animationEnded", nextTimeout)
                sliderInstance.on("updated", nextTimeout)

                $('#Carousel').removeClass('opacity-0');

                // Force lazysizes to recalculate image sizes after carousel becomes visible
                // This fixes blurry images on mobile refresh where container dimensions
                // were calculated incorrectly when carousel was hidden
                setTimeout(function() {
                    if (window.lazySizes) {
                        var carouselImages = $('#Carousel').find('.lazyload');
                        
                        carouselImages.each(function() {
                            var $img = $(this);
                            
                            // For images that haven't loaded yet, force recalculation
                            if (!$img.hasClass('lazyloaded')) {
                                // Temporarily remove and re-add data-sizes to force recalculation
                                var currentSizes = $img.attr('data-sizes');
                                $img.removeAttr('data-sizes');
                                // Force a reflow
                                $img[0].offsetHeight;
                                $img.attr('data-sizes', currentSizes || 'auto');
                            }
                        });
                        
                        // Force lazysizes to check elements and recalculate sizes
                        if (window.lazySizes.autoSizer) {
                            window.lazySizes.autoSizer.checkElems();
                        }
                        
                        // Trigger resize event to force recalculation
                        window.dispatchEvent(new Event('resize'));
                    }
                }, 100);

                $('#Carousel').on('mousemove mouseenter', function (e) {
                    $('#CursorText').show().css({ left: e.clientX, top: e.clientY });
                    if (e.clientX < $('#Carousel').width() / 2) {
                        $('#Carousel').removeClass('carousel-mouse-right').addClass('carousel-mouse-left');
                        $('#CursorText').text('Prev');
                    } else {
                        $('#Carousel').removeClass('carousel-mouse-left').addClass('carousel-mouse-right');
                        $('#CursorText').text('Next');
                    }
                }).on('click', function (e) {
                    navigating = true;
                    $('body').removeClass('product-info-shown');
                    if (sliderInstance) {
                        sliderInstance.update();
                    }
                    if (e.clientX < $('#Carousel').width() / 2) {
                        instance.prev()
                    } else {
                        instance.next()
                    }
                }).on('mousedown', function () {
                    $(this).addClass('mousedown')
                }).on('mouseup', function () {
                    $(this).removeClass('mousedown')
                }).on('mouseleave', function () {
                    $('#CursorText').hide();
                });

                var dots_wrapper = document.getElementById("dots")
                var slides = document.querySelectorAll(".keen-slider__slide")
                $('#dots').html('');
                slides.forEach(function (t, idx) {
                    var dot = document.createElement("button")
                    dot.classList.add("dot")
                    dots_wrapper.appendChild(dot)
                    dot.addEventListener("click", function () {
                        sliderInstance.moveToSlide(idx)
                    })
                })
                updateClasses()
            },
            slideChanged(instance) {
                updateClasses()
            },
        })

        function updateClasses(instance) {
            var slide = sliderInstance.track.details.rel

            var dots = document.querySelectorAll(".dot")
            dots.forEach(function (dot, idx) {
                idx === slide
                    ? dot.classList.add("dot--active")
                    : dot.classList.remove("dot--active")
            })
        }
    }
}

function initClock() {
    const $time = $('[data-current-time]');
    setInterval(() => {
        $time.html((moment().format("hh:mm:ss")) + " ET")
    }, 1000);
}

function updateMenu(href) {
    $('a[data-main-nav]').each(function (index) {
        if ($(this).attr('href') !== href) {
            $(this).removeClass('active');
        } else {
            // match
            $(this).addClass('active');
        }
    });
}

function initPDP() {
    // 1. If scrolled past container manually remove from DOM
    // 2. Barba transition to previous page
    initCarousel();
    console.log('init pdp')
    
    let $dummy = $('[data-product-container]').find('.scroll-dummy')
    scrolledPast = false;
    

    if (!$activeThumb && !$activeProduct) {
        // active product doesn't exist so create a clone of the first slide
        let handle = $('[data-barba-namespace="product"]').attr('data-handle');
        $activeThumb = $(`.grid-image-container[data-handle="${handle}"]`);
        $('.grid-image-container:not(.active-product)').removeClass('opacity-0 pointer-events-none transition-all duration-300');
        $activeProduct = $activeThumb.clone().removeClass('opacity-0 transition-none relative').addClass('active-product fixed pointer-events-none hidden').css({ left: 0, top: 0, width: "100%", height: "var(--vh)" }).appendTo($('#Index'))
        if (indexMode === 'grid') {
            $activeProduct.addClass('duration-300');
        } else {
            $activeProduct.addClass('duration-200');
        }
    }

    // <span class="mono ml-6 hidden md:inline">(ℹ)</span>
    let label = `<span class="mr-4">${$('[data-product-container]').data('number')}</span><h1 class="uppercase">${$('[data-product-container]').data('title')}</h1><button role="button" aria-label="Read" data-read-more-button class="hidden md:flex items-center h-full uppercase ml-8 group-hover:text-black">(More)</button>    `;
    $('#ProductLabel').html(label);

    $dummy.on('click', function () {
        $('[data-product-container]').animate({ scrollTop: $('[data-product-container]')[0].scrollHeight + 'px' }, 600, 'linear');
    })

    $('[data-product-label]').off('click').on('click', function () {
        console.log('click')
        $('body').toggleClass('product-info-shown')
        if (slider) {
            console.log('go to first slide')
            console.log(slider)
            slider.moveToIdx(0);
            slider.update();
            slider.moveToIdx(0);
        }
        if($('body').hasClass('product-info-shown')){
            $('[data-read-more-button]').text('(Less)')
        } else {
            $('[data-read-more-button]').text('(More)')
        }
    });

    $('[data-product-container]').on('scroll', function () {
        let st = $(this).scrollTop();
        console.log('st', st + $(window).height());
        console.log('[data-product-content-container] height', $('[data-product-content-container]').height())
        if ($dummy.position().top <= 5) {
            console.log('barba go to index')
            $('[data-product-container]').off('scroll');
            scrolledPast = true;
            barba.go('/pages/index');
            $('[data-product-container]').hide();
        }
        if (st + $(window).height() > $('[data-product-content-container]').height()) {
            scrolledPast = true;
            console.log('scrolled past: true')
            // $('#CursorText').hide();
        } else {
            scrolledPast = false;
            console.log('scrolled past: false')
            // $('#CursorText').show();
        }
        let opacity = ($dummy.position().top / $(this).scrollTop())
        $dummy.css('opacity', opacity);
        $index.css('opacity', 1 - opacity);
        $('[data-back-to-archive]').css('opacity', opacity);
        if ($(window).width() > 768) {
            $('#dots').css('opacity', opacity);
            $('[ data-product-button]').css('opacity', opacity);
        }
    })

    
}



function removeClasses() {
    $('body').removeClass('product-info-shown');
}

function initLogo(){
    var isFinished = false,
    isOver = false;

    var logo = new Vivus('logo-svg', { duration: 50, reverseStack: false, type: "scenario", onReady: function(){
        $('#LogoMark').removeClass('hidden');
    } }, function(){
        // console.log('done')
        isFinished = true;
        if(!isOver) $('#LogoMark').fadeOut();
    });

    $('#LogoLink').on('mouseenter', function(){
        if(isFinished){
            console.log('play again')
            isOver = true;
            $('#LogoMark').show();
            logo.stop().reset().play();
        }
    }).on('mouseleave', function(){
        $('#LogoMark').fadeOut();
        isOver = false;
    });

}

function initPDP(){
    if($('[data-product-label]').length > 0) {
        $('[data-product-label]').off('click').on('click', function () {
            console.log('click')
            $('body').toggleClass('product-info-shown')
            if (slider) {
                console.log('go to first slide')
                console.log(slider)
                slider.moveToIdx(0);
                slider.update();
                slider.moveToIdx(0);
            }
            if($('body').hasClass('product-info-shown')){
                $('[data-read-more-button]').text('(Less)')
            } else {
                $('[data-read-more-button]').text('(More)')
            }
        });

        initCarousel();
        let label = `<span class="mr-4">${$('[data-product-container]').data('number')}</span><h1 class="uppercase">${$('[data-product-container]').data('title')}</h1><button role="button" aria-label="Read" data-read-more-button class="hidden md:flex items-center h-full uppercase ml-8 group-hover:text-black">(More)</button>    `;
        $('#ProductLabel').html(label);
    }

}



initPDP();
initLogo();
setTimer();
initLazySizes();
initCarousel();
initClock();
winResize();
window.addEventListener("resize", winResize); 